import styled from '@emotion/styled';

export const LayoutRowStyled = styled.div`
  margin-top: 24px;
`;

export const WidthWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;

  .MuiInputBase-root.MuiOutlinedInput-root {
    height: 40px;
  }

  .MuiInputLabel-root {
    line-height: 25px;
  }

  p {
    margin-bottom: 5px;
  }

  > :last-child {
    margin-top: 16px;
  }
`;
